import React, { useState, useContext, useEffect } from "react";
import { getAllBanks } from "../../../stores/services/bank.service";
import { getAmc } from "../../../stores/services/amc.service";
import { getBranchByBankName } from "../../../stores/services/branch.service";
import {
  addAccount,
  getAccountByAmcAccountNo,
  getAccountByAmcGlCode,
} from "../../../stores/services/account.service";
import { getFundByAmc } from "../../../stores/services/funds.service";
import ReactTooltip from "react-tooltip";
import { Container, Row, Col, FormGroup, Input, Label } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useHistory } from "react-router-dom";
import {
  accountPurposeOptions,
  accountTitle_AccountNumber_Regex,
  getAllLedgers,
} from "../../../utils/customFunction";
import NumberFormat from "react-number-format";
import { Autocomplete, Paper, TextField } from "@mui/material";
import { ThemeContext } from "../../../contexts/ThemeContext";
import { useSelector, useDispatch } from "react-redux";
import {
  getChartOfAccounts,
  getNewChartsOfAccountsByFund,
  replaceChartOfAccountsFile,
} from "../../../stores/services/chatofaccounts.service";
import { GetChartOfAccount } from "../../../redux/actions/chartOfAccount-Actions";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";

const SetupAccount = () => {
  const NatureAccountArr = [
    { label: "Current", value: "Current" },
    { label: "PLS", value: "PLS" },
  ];
  const CurrencyArr = [
    { label: "PKR", value: "PKR", defaultChecked: true },
    { label: "USD", value: "USD" },
  ];

  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

  const history = useHistory();
  const context = useContext(ThemeContext);
  const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
  // const dispatch = useDispatch();
  //hooks for getting all inputs from user
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const [bankname, setBankName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [amcName, setAmcName] = useState(amcCode);
  const [city, setCity] = useState("");
  const [fund, setFund] = useState("");
  const [currency, setCurrency] = useState("PKR");
  const [txNature, setTxNature] = useState("");
  const [iban, setIban] = useState("");
  const [accType, setAccType] = useState("");
  const [accPurpose, setAccPurpose] = useState("");
  const [amount, setAmount] = useState("0");
  const [headEmail, setHeadEmail] = useState("");
  const [headPhone, setHeadPhone] = useState("");
  const [branchHeadEmail, setBranchHeadEmail] = useState("");
  const [branchHeadMobile, setBranchHeadMobile] = useState("");
  const [folioNo, setFolioNo] = useState("");
  const [currentBalance, setCurrentBalance] = useState("0");
  const [currentBalanceError, setCurrentBalanceError] =
    useState<boolean>(false);

  const [interestRate, setInterestRate] = useState<any>("");
  const [debitBankProfitLedger, setDebitBankProfitLedger] = useState<any>();
  const [creditBankProfitLedger, setCreditBankProfitLedger] = useState<any>();
  const [associatedLedgerExpense, setAssociatedLedgerExpense] = useState<any>();
  const [interestRateError, setInterestRateError] = useState<boolean>(false);
  const [debitBankProfitLedgerError, setDebitBankProfitLedgerError] =
    useState<boolean>(false);
  const [creditBankProfitLedgerError, setCreditBankProfitLedgerError] =
    useState<boolean>(false);
  const [associatedLedgerExpenseError, setAssociatedLedgerExpenseError] =
    useState<boolean>(false);

  const [ledgerOption, setLedgerOption] = useState<any>([]);
  const [allLedgerData, setAllLedgerData] = useState<any>([]);

  // const chartOfAccounts = useSelector((state: any) => state.chartofAccounts);
  const [chartOfAccounts, setChartOfAccounts] = useState<any>(undefined);
  const [accountPurpose, setAccountPurpose] = useState("");

  useEffect(() => {
    if (chartOfAccounts && chartOfAccounts?.length > 0) {
      setLedgersData();
    }
  }, [chartOfAccounts]);

  const getChartOfAccountsFromBackend = async () => {
    try {
      setLoading(true);
      let response = await getNewChartsOfAccountsByFund(email, amcCode, fund);
      if (response.data.status === 200) {
        setChartOfAccounts(response.data.data?.main_family);
        setLoading(false);
      } else {
        toast.error("No associated chart of account!");

        setChartOfAccounts(undefined);
      }
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message?.toString());
      } else {
        toast.error(err.message || "Request Failed!");
      }
    }
  };

  useEffect(() => {
    if (fund) {
      getChartOfAccountsFromBackend();
    }
  }, [fund]);

  const setLedgersData = async () => {
    setAllLedgerData(await getAllLedgers(chartOfAccounts));
  };

  const email = sessionStorage.getItem("email") || "";
  const [fundLoading, setFundLoading] = useState<boolean>(false);
  const [smaCheck, setSmaCheck] = useState<boolean>(false);

  useEffect(() => {
    allLedgerData.map((item, index) => {
      if (index === 0) {
        if (item.name) {
          return setLedgerOption([
            {
              label: `${item.code} - ${item.name}`,
              value: item.code,
            },
          ]);
        } else if (item.bank) {
          return setLedgerOption([
            {
              label: `${item.code} - ${item.bank}`,
              value: item.code,
            },
          ]);
        }
      }

      if (item.name) {
        return setLedgerOption((prevState) => [
          ...prevState,
          {
            label: `${item.code} - ${item.name}`,
            value: item.code,
          },
        ]);
      } else if (item.bank) {
        return setLedgerOption((prevState) => [
          ...prevState,
          {
            label: `${item.code} - ${item.bank}`,
            value: item.code,
          },
        ]);
      }
    });
  }, [allLedgerData]);

  // const getfundByAmcCode = async (amcName: string) => {
  //   setFundLoading(true);
  //   // allFunds.length = 0;
  //   // setAllFunds(allFunds);
  //   //get funds by amc for dropdown
  //   try {
  //     const response = await getFundByAmc(email, amcName);
  //     setAllFunds(response.data.data);
  //   } catch (error) {}
  //   setFundLoading(false);
  // };
  //error getting hooks

  const [bankNameError, setBankNameError] = useState("");
  const [branchNameError, setBranchNameError] = useState("");
  const [amcNameError, setAmcError] = useState("");
  const [fundError, setFundError] = useState("");
  const [currencyError, setCurrencyError] = useState("");
  const [txNatureError, setTxNatureError] = useState("");
  const [ibanError, setIbanError] = useState("");
  const [accTypeError, setAccTypeError] = useState("");
  const [accPurposeError, setAccPurposeError] = useState("");
  const [headEmailError, setHeadEmailError] = useState("");
  const [amountError, setAmountError] = useState("");
  const [folioNoError, setFolioNoError] = useState("");
  const [cityError, setCityError] = useState("");

  const [Loading, setLoading] = useState(false);
  //for dropdown data
  const [amcdata, setAmcdata] = useState<any>([]);
  const [bankNameData, setBankNameData] = useState<any>([]);
  const [allbranchesData, setAllBranchesData] = useState<any>([]);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [branchCheckFlag, setBranchCheckFlag] = useState(false);

  const [headPhoneError, setHeadPhoneError] = useState("");
  const [branchHeadEmailError, setBranchHeadEmailError] = useState("");
  const [branchHeadMobileError, setBranchHeadMobileError] = useState("");

  const getBranchByName = async (name: string) => {
    allbranchesData.length = 0;
    setAllBranchesData(allbranchesData);
    //get all branches for selected bank for dropdown
    try {
      const response = await getBranchByBankName(email, name, amcCode);
      setAllBranchesData(response.data.data);
      if (response.data.data.length > 0) {
        setBranchCheckFlag(false);
      } else {
        setBranchCheckFlag(true);
      }
    } catch (error) {}
  };
  React.useEffect(() => {
    const fetchAmc = async () => {
      amcdata.length = 0;
      setAmcdata(amcdata);
      bankNameData.length = 0;
      setBankNameData(bankNameData);
      //get all Amc for dropdown
      // try {
      //   const amcResponse = await getAmc(email);
      //   setAmcdata(amcResponse.data.data);
      // } catch (error) {}

      // get funds by amcCode
      setFundLoading(true);
      // allFunds.length = 0;
      // setAllFunds(allFunds);
      //get funds by amc for dropdown
      try {
        const response = await getFundByAmc(
          email,
          amcName,
          fund_code?.length > 0 ? fund_code : ""
        );
        setAllFunds(response.data.data);
      } catch (error) {}
      setFundLoading(false);

      //get all banks list for dropdown
      try {
        const response = await getAllBanks(email, "", "", amcCode);
        setBankNameData(response.data.data);
      } catch (error) {}
      //get tx nature data for dropdown
    };
    fetchAmc();
  }, []);
  //render dropdown for amc data
  // const renderAmcDropdown = () => {
  //   return amcdata.map((item: any, index: string) => {
  //     return (
  //       <option key={index} value={item.amc_code.replace('AMC_','')}>
  //         {item.name} ({item.amc_code.replace('AMC_','')})
  //       </option>
  //     );
  //   });
  // };
  //render dropdown for bank name data
  // const renderBankNameDropdown = () => {
  //   return bankNameData.map((item: any, index: string) => {
  //     return (
  //       <option key={index} value={item.bank_code.replace("BANK_", "")}>
  //         {item.bank_name} ({item.bank_code.replace("BANK_", "")})
  //       </option>
  //     );
  //   });
  // };

  const renderBankNameDropdown = () => {
    return bankNameData.map((item: any, index: string) => {
      return {
        value: item.bank_code.replace("BANK_", ""),
        label: `${item.bank_name} (${item.bank_code.replace("BANK_", "")})`,
      };
    });
  };
  //render dropdown for branch name data
  const renderBranchsDropdown = () => {
    return allbranchesData.map((item: any, index: string) => {
      return (
        <option key={index} value={item.branch_code}>
          {item.branch_name} ({item.branch_code})
        </option>
      );
    });
  };

  // const renderFundsDropdown = () => {
  //   return allFunds.map((item: any, index: string) => {
  //     return (
  //       <option key={index} value={item.symbol_code}>
  //         {` ${item.fund_name} (${item.symbol_code})`}
  //       </option>
  //     );
  //   });
  // };

  const renderFundsDropdown = () => {
    return allFunds.map((item: any, index: string) => {
      return {
        value: item.symbol_code,
        label: ` ${item.fund_name} (${item.symbol_code})`,
      };
    });
  };
  //render dropdown for nature of transaction data
  const validate = () => {
    let bankErr,
      branchErr,
      amcErr,
      fundErr,
      currencyErr = "";
    let txErr,
      ibanErr,
      accErr,
      accPurErr,
      amountErr,
      headEmailErr,
      headPhoneErr,
      branchHEmailerr,
      cityErr,
      interestRateErr,
      // debitBankProfitLedgerErr,
      // creditBankProfitLedgerErr,
      BranchHPhoneErr = "";
    bankname.trim() === "" ? (bankErr = "Required") : (bankErr = "");
    branchName.trim() === "" ? (branchErr = "Required") : (branchErr = "");
    amcName.trim() === "" ? (amcErr = "Required") : (amcErr = "");
    fund.trim() === "" ? (fundErr = "Required") : (fundErr = "");
    // currency.trim() === '' ? currencyErr = "Required" : currencyErr = "";
    txNature.trim() === "" ? (txErr = "Required") : (txErr = "");
    iban.trim() === "" ? (ibanErr = "Required") : (ibanErr = "");
    accType.trim() === "" ? (accErr = "Required") : (accErr = "");
    city.trim() === "" ? (cityErr = "Required") : (cityErr = "");
    if (txNature === "PLS") {
      interestRate.trim() === ""
        ? (interestRateErr = "required-border")
        : (interestRateErr = "");
    } else {
      interestRateErr = "";
    }

    // !debitBankProfitLedger?.value
    //   ? (debitBankProfitLedgerErr = "required-border")
    //   : (debitBankProfitLedgerErr = "");
    // !creditBankProfitLedger?.value
    //   ? (creditBankProfitLedgerErr = "required-border")
    //   : (creditBankProfitLedgerErr = "");
    // amount.trim() === '' ? amountErr = "Required" : amountErr = '';
    // headEmail.trim() === '' ? headEmailErr = "Required" : headEmailErr = '';

    // headPhone.trim() === '' ? headPhoneErr = "Required" : headPhoneErr = '';
    // branchHeadEmail.trim() === '' ? branchHEmailerr = "Required" : branchHEmailerr = '';
    // branchHeadMobile.trim() === '' ? BranchHPhoneErr = "Required" : BranchHPhoneErr = '';

    if (
      bankErr ||
      branchErr ||
      amcErr ||
      headPhoneErr ||
      branchHEmailerr ||
      BranchHPhoneErr ||
      fundErr ||
      ibanErr ||
      currencyErr ||
      txErr ||
      accErr ||
      accPurErr ||
      amountErr ||
      cityErr ||
      interestRateErr
      // ||
      // debitBankProfitLedgerErr ||
      // creditBankProfitLedgerErr
    ) {
      setBankNameError(bankErr);
      setCityError(cityErr);
      //setHeadPhoneError(headPhoneErr);
      // setBranchHeadMobileError(BranchHPhoneErr);
      // setBranchHeadEmailError(branchHEmailerr);
      setBranchNameError(branchErr);
      setAmcError(amcErr);
      setFundError(fundErr);
      setCurrencyError(currencyErr);
      setTxNatureError(txErr);
      setAccTypeError(accErr);
      setIbanError(ibanErr);
      setAccPurposeError(accPurErr);
      setAmountError(amountErr);
      setHeadEmailError(headEmailErr);
      setInterestRateError(interestRateErr);
      // setDebitBankProfitLedgerError(debitBankProfitLedgerErr);
      // setCreditBankProfitLedgerError(creditBankProfitLedgerErr);
      return false;
    } else {
      return true;
    }
  };
  const addAccountProcess = async () => {
    const isValid = validate();
    if (!isValid) {
      toast.error("Please Fill All Required Fields");
      return;
    }

    setLoading(true);

    try {
      const initialAccountCheck = await getAccountByAmcAccountNo(
        email,
        amcCode,
        iban
      );

      if (
        initialAccountCheck &&
        initialAccountCheck.status === 200 &&
        initialAccountCheck.data.status === 200
      ) {
        toast.error("Account No already exists!");
        setLoading(false);
        return;
      }

      // === DYNAMIC FINDINGS ===
      const assetsFamily = chartOfAccounts.find((f) => f.name === "ASSETS");
      const incomeFamily = chartOfAccounts.find((f) => f.name === "INCOME");

      if (!assetsFamily || !incomeFamily) {
        toast.error("Chart of accounts is missing required sections.");
        setLoading(false);
        return;
      }

      // Find BANK BALANCES under ASSETS.family
      const bankBalances = assetsFamily.family?.find(
        (f) => f.name === "BANK BALANCES"
      );

      // Find ACCRUED PROFIT RECEIVABLE
      const accruedProfitReceivable = assetsFamily.family?.find(
        (f) => f.name === "ACCRUED PROFIT RECEIVABLE"
      );

      // Find MARK UP INCOME under INCOME.family
      const markupIncome = incomeFamily.family?.find(
        (f) => f.name === "MARK UP INCOME"
      );

      if (!bankBalances || !accruedProfitReceivable || !markupIncome) {
        toast.error(
          "Required account categories not found in chart of accounts."
        );
        setLoading(false);
        return;
      }

      // Extract sub_families safely
      let temp = [...(bankBalances.sub_family || [])];
      let tempForInterestAsset =
        accruedProfitReceivable.sub_family?.[0] || null;

      // For interest income: find "ACCRUED PROFIT RECEIVABLE" inside MARK UP INCOME -> child_family[0]
      let tempForInterest: any = null;
      for (const sub of markupIncome.sub_family || []) {
        if (
          sub.name === "ACCRUED PROFIT RECEIVABLE" &&
          sub.child_family?.length > 0
        ) {
          tempForInterest = sub.child_family[0];
          break;
        }
      }

      if (!tempForInterest) {
        toast.error("Interest income ledger configuration missing.");
        setLoading(false);
        return;
      }

      // Determine account type: Current or PLS
      const accountTypeName =
        txNature === "Current" ? "CURRENT ACCOUNTS" : "PLS ACCOUNTS";
      const selectedAccount = temp.find(
        (item) => item.name === accountTypeName
      );

      if (!selectedAccount) {
        toast.error(`${accountTypeName} not found in BANK BALANCES.`);
        setLoading(false);
        return;
      }

      // === Generate GL Codes ===
      let gl_code =
        selectedAccount.gl?.length > 0
          ? selectedAccount.gl[selectedAccount.gl.length - 1].code + 1
          : parseInt(`${selectedAccount.code}01`);

      let gl_code_interest_asset =
        tempForInterestAsset?.gl?.length > 0
          ? tempForInterestAsset.gl[tempForInterestAsset.gl.length - 1].code + 1
          : parseInt(`${tempForInterestAsset?.code}01`);

      let gl_code_interest =
        tempForInterest.gl?.length > 0
          ? tempForInterest.gl[tempForInterest.gl.length - 1].code + 1
          : parseInt(`${tempForInterest.code}01`);

      // === Ensure GL codes are unique ===
      let accountCheck;
      do {
        accountCheck = await getAccountByAmcGlCode(
          email,
          amcCode,
          gl_code,
          fund
        );
        if (accountCheck?.status === 200 && accountCheck.data.status === 200) {
          gl_code++;
        }
      } while (
        accountCheck?.status === 200 &&
        accountCheck.data.status === 200
      );

      // Add new bank GL
      const newBankGl = {
        name: `${fund} ${bankname} ${branchName} (${iban.slice(-4)})`,
        gl_name: `${fund} ${bankname} ${branchName} (${iban.slice(-4)})`,
        account_no: iban,
        account_title: accType,
        active: true,
        balance: currentBalance?.toString() || "0",
        bank: bankname,
        branch: branchName,
        code: gl_code,
        interest_rate: interestRate?.toString() || "0",
        related_ledgers: [gl_code_interest_asset, gl_code_interest],
        account_purpose: accountPurpose,
      };

      selectedAccount.gl.push(newBankGl);

      // Update temp with modified GLs
      temp = temp.map((item) =>
        item.name === accountTypeName ? selectedAccount : item
      );

      // === Add main account ===
      const response = await addAccount(
        email,
        amcCode,
        bankname,
        branchName,
        iban,
        fund,
        accType,
        txNature,
        currency,
        currentBalance,
        headEmail,
        smaCheck,
        headPhone,
        branchHeadEmail,
        branchHeadMobile,
        folioNo,
        city,
        gl_code,
        accountPurpose
      );

      if (response.data.status !== 200) {
        toast.error(response.data.message);
        setLoading(false);
        return;
      }

      // === Only proceed with interest ledgers if txNature is PLS ===
      if (txNature === "PLS" && tempForInterestAsset && tempForInterest) {
        // --- Create Accrued Return GL ---
        let accountCheckAsset;
        do {
          accountCheckAsset = await getAccountByAmcGlCode(
            email,
            amcCode,
            gl_code_interest_asset,
            fund
          );
          if (
            accountCheckAsset?.status === 200 &&
            accountCheckAsset.data.status === 200
          ) {
            gl_code_interest_asset++;
          }
        } while (
          accountCheckAsset?.status === 200 &&
          accountCheckAsset.data.status === 200
        );

        const newInterestAssetGl = {
          name: `ACCRUED RETURN ON ${fund} ${bankname} ${branchName} (${iban.slice(
            -4
          )})`,
          gl_name: `ACCRUED RETURN ON ${fund} ${bankname} ${branchName} (${iban.slice(
            -4
          )})`,
          account_no: iban,
          account_title: accType,
          active: true,
          balance: currentBalance?.toString() || "0",
          bank: bankname,
          branch: branchName,
          code: gl_code_interest_asset,
          interest_rate: interestRate?.toString() || "0",
          related_ledgers: [gl_code_interest_asset, gl_code_interest],
        };

        if (!tempForInterestAsset.gl) tempForInterestAsset.gl = [];
        tempForInterestAsset.gl.push(newInterestAssetGl);

        await addAccount(
          email,
          amcCode,
          "Ledger",
          "Ledger",
          gl_code_interest_asset.toString(),
          fund,
          accType,
          txNature,
          currency,
          currentBalance,
          "",
          smaCheck,
          "",
          "Ledger",
          "Ledger",
          folioNo,
          "Ledger",
          gl_code_interest_asset,
          accountPurpose
        );

        // --- Create Interest Income GL ---
        let accountCheckIncome;
        do {
          accountCheckIncome = await getAccountByAmcGlCode(
            email,
            amcCode,
            gl_code_interest,
            fund
          );
          if (
            accountCheckIncome?.status === 200 &&
            accountCheckIncome.data.status === 200
          ) {
            gl_code_interest++;
          }
        } while (
          accountCheckIncome?.status === 200 &&
          accountCheckIncome.data.status === 200
        );

        const newInterestIncomeGl = {
          name: `INTEREST INCOME ON ${fund} ${bankname} ${branchName} (${iban.slice(
            -4
          )})`,
          gl_name: `INTEREST INCOME ON ${fund} ${bankname} ${branchName} (${iban.slice(
            -4
          )})`,
          account_no: iban,
          account_title: accType,
          active: true,
          balance: currentBalance?.toString() || "0",
          bank: bankname,
          branch: branchName,
          code: gl_code_interest,
          interest_rate: interestRate?.toString() || "0",
          related_ledgers: [gl_code_interest_asset, gl_code_interest],
        };

        if (!tempForInterest.gl) tempForInterest.gl = [];
        tempForInterest.gl.push(newInterestIncomeGl);

        await addAccount(
          email,
          amcCode,
          "Ledger",
          "Ledger",
          gl_code_interest.toString(),
          fund,
          accType,
          txNature,
          currency,
          currentBalance,
          "",
          smaCheck,
          "",
          "Ledger",
          "Ledger",
          folioNo,
          "Ledger",
          gl_code_interest,
          accountPurpose
        );

        // === Update chartOfAccounts dynamically ===
        // Update ACCRUED PROFIT RECEIVABLE → sub_family[0]
        const updatedAccruedSubFamily = accruedProfitReceivable.sub_family?.map(
          (sub) =>
            sub.name === tempForInterestAsset.name ? tempForInterestAsset : sub
        );
        accruedProfitReceivable.sub_family = updatedAccruedSubFamily;

        // Update MARK UP INCOME → find "ACCRUED PROFIT RECEIVABLE" → child_family[0]
        const updatedMarkupSubFamily = markupIncome.sub_family?.map((sub) => {
          if (sub.name === "ACCRUED PROFIT RECEIVABLE") {
            const updatedChild = sub.child_family?.map((child) =>
              child.name === tempForInterest.name ? tempForInterest : child
            );
            return { ...sub, child_family: updatedChild };
          }
          return sub;
        });
        markupIncome.sub_family = updatedMarkupSubFamily;
      }

      // === Update main chartOfAccounts ===
      const updatedChartOfAccounts = chartOfAccounts.map((family) => {
        if (family.name === "ASSETS") {
          return {
            ...family,
            family: family.family?.map((sub) => {
              if (sub.name === "BANK BALANCES") return bankBalances;
              if (sub.name === "ACCRUED PROFIT RECEIVABLE")
                return accruedProfitReceivable;
              return sub;
            }),
          };
        }
        if (family.name === "INCOME") {
          return {
            ...family,
            family: family.family?.map((sub) =>
              sub.name === "MARK UP INCOME" ? markupIncome : sub
            ),
          };
        }
        return family;
      });

      // === Save updated CoA ===
      await replaceChartOfAccountsFile(
        email,
        JSON.stringify({ main_family: updatedChartOfAccounts }),
        amcCode,
        fund
      );

      getChartOfAccountsFromBackend();

      toast.success(response.data.message);
      setTimeout(() => {
        history.replace(`/admin/bank-accounts`);
      }, 2000);
    } catch (error: any) {
      console.error("ERROR => ", error);
      setLoading(false);
      const message = error.response?.data?.message;
      toast.error(
        Array.isArray(message) ? message[0] : message || "Something went wrong"
      );
    }
  };

  const [codeChange, setCodeChange] = useState("");

  const decimalValue = (value, len) => {
    let startingValue = value.split(".")[0];
    let decimalVal = value.split(".")[1];
    let temp = "";
    if (decimalVal !== undefined) {
      let decimalString = decimalVal.toString();
      if (decimalString.length <= len) {
        temp = startingValue + "." + decimalString;
      } else {
        temp = startingValue + "." + decimalString.substr(0, len);
      }
    } else {
      temp = startingValue;
    }
    return temp;
  };

  const selectedFundName = React.useMemo(() => {
    const selectedFund =
      allFunds && allFunds?.find((item) => item?.symbol_code === fund);
    return selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: ` ${selectedFund.fund_name} (${selectedFund.symbol_code})`,
        }
      : null;
  }, [allFunds, fund]);

  const selectedBankName = React.useMemo(() => {
    const selectedFund =
      bankNameData &&
      bankNameData?.find(
        (item) => item?.bank_code.replace("BANK_", "") === bankname
      );
    return selectedFund
      ? {
          value: selectedFund.bank_code.replace("BANK_", ""),
          label: `${selectedFund.bank_name} (${selectedFund.bank_code.replace(
            "BANK_",
            ""
          )})`,
        }
      : null;
  }, [bankNameData, bankname]);

  const selectedNatureOfAccount = React.useMemo(() => {
    const selectedFund =
      NatureAccountArr &&
      NatureAccountArr?.find((item) => item?.value === txNature);
    return selectedFund
      ? {
          value: selectedFund.value,
          label: selectedFund.label,
        }
      : null;
  }, [NatureAccountArr, txNature]);

  const selectedCurrency = React.useMemo(() => {
    const selectedFund =
      CurrencyArr && CurrencyArr?.find((item) => item?.value === currency);
    return selectedFund
      ? {
          value: selectedFund.value,
          label: selectedFund.label,
        }
      : null;
  }, [CurrencyArr, currency]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
        ? "hsla(291, 64%, 42%, 1)"
        : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
        ? "#2b3553"
        : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="input-holder">
                <h4 className="card-title">
                  <i
                    className="fa fa-angle-left mr-1 pointer"
                    onClick={() => {
                      history.replace("/admin/bank-accounts");
                    }}
                  ></i>
                  Setup - Bank Account
                </h4>
                <Link
                  to="/admin/bank-accounts"
                  className="t-3 ml-auto btn btn-primary btn-sm"
                  replace
                >
                  <i className="fa fa-eye mr-2"></i>View All
                </Link>
              </div>

              <Row>
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Fund Detail</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label>
                          Fund Selection <span className="color-amber">*</span>
                        </label>
                        <ReactTooltip
                          textColor="white"
                          backgroundColor="black"
                          effect="float"
                        />
                        <div className="" data-tip="First Select Amc">
                          {fundLoading ? (
                            <div className="form-group">
                              <div className="ml-2 form-control">
                                Fund Loading
                                <i
                                  className="fa fa-spinner fa-spin fa-1x ml-2"
                                  aria-hidden="true"
                                ></i>
                              </div>
                            </div>
                          ) : (
                            <Select
                              className={fundError ? "required-border" : ""}
                              value={selectedFundName}
                              label={"Select Fund"}
                              onChange={(e) => {
                                setFundError("");
                                setFund(e?.value);
                              }}
                              menuPortalTarget={document.body}
                              menuShouldBlockScroll={true}
                              isClearable={true}
                              isSearchable={true}
                              name="color"
                              options={renderFundsDropdown()}
                              styles={customStyles}
                            />
                          )}
                        </div>
                      </div>

                      <div className="form-group">
                        <label className="text-start fw-bold w-100 mb-1">
                          Select Account Purposes{" "}
                        </label>
                        <MultiSelect
                          options={accountPurposeOptions.map((option) => ({
                            label: option,
                            value: option,
                          }))}
                          value={accountPurposeOptions
                            .filter((option) => accountPurpose.includes(option))
                            .map((option) => ({
                              label: option,
                              value: option,
                            }))}
                          onChange={(selectedOptions) => {
                            setAccountPurpose(
                              selectedOptions.map((opt) => opt.value)
                            );
                          }}
                          labelledBy={"Select Account Purposes"}
                          className={`multi-select reportTxn-multi-select-${theme}`}
                          overrideStrings={{
                            selectAll: "Select all Purposes",
                            selectSomeItems: "Select Account Purposes",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Bank Detail</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label>
                          Bank Name <span className="color-amber">*</span>
                        </label>
                        <Select
                          className={`${
                            bankNameError ? "required-border" : ""
                          }`}
                          value={selectedBankName}
                          label={"Select Bank Name"}
                          onChange={(e) => {
                            setBankNameError("");
                            setBankName(e?.value);
                            getBranchByName(e?.value);
                          }}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll={true}
                          isClearable={true}
                          isSearchable={true}
                          name="color"
                          options={renderBankNameDropdown()}
                          styles={customStyles}
                        />
                        {/* <select
                          className={`form-control  w-100 ${bankNameError ? "required-border" : ""
                            }`}
                          value={bankname}
                          onChange={(e) => {
                            setBankNameError("");
                            setBankName(e.target.value);
                            getBranchByName(e.target.value);
                          }}
                        >
                          <option value="" defaultChecked hidden>
                            {" "}
                            Select Bank
                          </option>
                          {renderBankNameDropdown()}
                        </select> */}
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              Branch Name <span className="color-amber">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                branchNameError ? "required-border" : ""
                              }`}
                              value={branchName}
                              onChange={(e) => {
                                setBranchNameError("");
                                setBranchName(e.target.value);
                              }}
                            />
                            {/* <select	
                    className={`form-control  w-100 ${branchNameError ? 'required-border' : ''	
                      }`}	
                    value={branchName}	
                    onChange={(e) => {	
                      setBankNameError('');	
                      setBranchName(e.target.value);	
                    }}	
                  >	
                    <option value="" defaultChecked hidden>	
                      {branchCheckFlag	
                        ? 'No Branch Found'	
                        : 'Select Branch Name'}	
                    </option>	
                    {renderBranchsDropdown()}	
                  </select>	 */}
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              City <span className="color-amber">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                cityError ? " required-border" : ""
                              }`}
                              value={city}
                              onChange={(e) => {
                                setCityError("");
                                setCity(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Special Managed Account</h4>
                    </div>
                    <div className="card-body">
                      <FormGroup check className="mt-4">
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={smaCheck}
                            onChange={(e) => {
                              if (smaCheck) {
                                setSmaCheck(false);
                                setFolioNo("");
                              } else {
                                setSmaCheck(true);
                              }
                            }}
                          />
                          <span className="form-check-sign" />
                          SMA (Optional)
                        </Label>
                      </FormGroup>

                      {smaCheck && (
                        <div className="form-group mt-4">
                          <label>Main Folio No</label>
                          <input
                            type="text"
                            placeholder="Folio No"
                            className={`form-control  w-100 ${
                              folioNoError ? "required-border" : ""
                            }`}
                            value={folioNo}
                            onChange={(e) => {
                              setFolioNo(e.target.value);
                              setFolioNoError("");
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Second Row */}
              <Row>
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Contact Detail</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label>Operation Manager Email </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Operation Manager Email"
                          value={headEmail}
                          onChange={(e) => {
                            setHeadEmail(e.target.value);
                            setHeadEmailError("");
                          }}
                        />
                        {/* {headEmailError ? (	
                    <p className="error-labels error-message2">	
                      {headEmailError}	
                    </p>	
                  ) : (	
                    ''	
                  )}	 */}
                      </div>

                      <div className="form-group">
                        <label>Operation Manager Phone </label>
                        {/* <input	
                    type="text"	
                    placeholder="Operation Manager Phone"	
                    className={`form-control  w-100 ${headPhoneError ? 'required-border' : ''	
                      }`}	
                    value={headPhone}	
                    onChange={(e) => {	
                      setHeadPhone(e.target.value);	
                      setHeadPhoneError('');	
                    }}	
                  />	 */}
                        <PhoneInput
                          specialLabel=""
                          inputClass={`form-control  w-100 ${
                            headPhoneError ? "" : ""
                          }`}
                          country={"pk"}
                          placeholder="+92 123-1234567"
                          value={headPhone}
                          onChange={(e) => {
                            setHeadPhone(e);
                            setHeadPhoneError("");
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label>Branch Manager Email </label>
                        <input
                          type="text"
                          placeholder="Branch Manager Email"
                          className={`form-control  w-100 ${
                            branchHeadEmailError ? "" : ""
                          }`}
                          value={branchHeadEmail}
                          onChange={(e) => {
                            setBranchHeadEmail(e.target.value);
                            setBranchHeadEmailError("");
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label>Branch Manager Phone </label>
                        {/*  <span className="color-amber">*</span> */}
                        {/* <input	
                    type="number"	
                    placeholder="Branch Manager Phone"	
                    className={`form-control  w-100 ${branchHeadMobileError ? 'required-border' : ''	
                      }`}	
                    value={branchHeadMobile}	
                    onChange={(e) => {	
                      setBranchHeadMobile(e.target.value);	
                      setBranchHeadMobileError('');	
                    }}	
                  />	 */}
                        <PhoneInput
                          specialLabel=""
                          inputClass={`form-control  w-100 ${
                            branchHeadMobileError ? "" : ""
                          }`}
                          country={"pk"}
                          placeholder="+92 123-1234567"
                          value={branchHeadMobile}
                          onChange={(e) => {
                            setBranchHeadMobile(e);
                            setBranchHeadMobileError("");
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Account Detail</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label>
                          Bank Account Title{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Bank Account Title"
                          className={`form-control  w-100 ${
                            accTypeError ? " required-border" : ""
                          }`}
                          value={accType}
                          onChange={(e) => {
                            if (
                              e.target.value.match(
                                accountTitle_AccountNumber_Regex
                              ) ||
                              e.target.value == ""
                            ) {
                              setAccType(e.target.value);
                              setAccTypeError("");
                            }
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label>
                          IBAN <span className="color-amber">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="IBAN"
                          className={`form-control  w-100 ${
                            ibanError ? "required-border" : ""
                          }`}
                          value={iban}
                          onChange={(e) => {
                            if (
                              e.target.value.match(
                                accountTitle_AccountNumber_Regex
                              ) ||
                              e.target.value == ""
                            ) {
                              setIban(e.target.value);
                              setIbanError("");
                            }
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label>
                          Nature of Account{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <Select
                          className={`${
                            txNatureError ? "required-border" : ""
                          }`}
                          value={selectedNatureOfAccount}
                          label={"Select Nature"}
                          onChange={(e) => {
                            setTxNatureError("");
                            setTxNature(e?.value);
                          }}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll={true}
                          isClearable={true}
                          isSearchable={true}
                          name="color"
                          options={NatureAccountArr}
                          styles={customStyles}
                        />
                      </div>

                      <div className="form-group">
                        <label>Currency</label>
                        <Select
                          className={`${
                            currencyError ? "required-border" : ""
                          }`}
                          value={selectedCurrency}
                          label={"Select"}
                          onChange={(e) => {
                            setCurrencyError("");
                            setCurrency(e?.value);
                          }}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll={true}
                          isClearable={true}
                          isSearchable={true}
                          name="color"
                          options={CurrencyArr}
                          styles={customStyles}
                        />
                      </div>

                      {txNature === "PLS" ? (
                        <div
                          className="form-group"
                          data-tip="Interest rate for Bank Profit"
                        >
                          <label>
                            Interest Rate %{" "}
                            <span className="color-amber">*</span>
                          </label>
                          {/* <input
                            type="number" */}
                          <NumberFormat
                            thousandSeparator={true}
                            inputMode="numeric"
                            decimalScale={4}
                            placeholder="Interest rate to calculate bank profit"
                            value={parseFloat(interestRate || "0")?.toFixed(4)}
                            className={`form-control w-100 ${interestRateError}`}
                            style={{ textAlign: "right" }}
                            onChange={(e) => {
                              // console.log("e.target.value", e.target.value);
                              setInterestRateError(false);
                              setInterestRate(
                                parseFloat(e.target.value || "0")?.toFixed(4)
                              );
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="form-group">
                <button
                  className="btn btn-primary "
                  onClick={addAccountProcess}
                  disabled={Boolean(Loading)}
                >
                  {Loading ? (
                    <>
                      <span
                        className="spinner-border login-txt spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="login-txt"> Loading...</span>
                    </>
                  ) : (
                    <span>Create</span>
                  )}
                </button>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default SetupAccount;
